import React, {useState, useEffect} from 'react'
import Breadcumb from '../../../components/Breadcumb/Breadcumb'
import { Container, Card, CardContent, Grid, TextField, Button } from '@material-ui/core'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useDropzone } from 'react-dropzone';
import { Categories, Alerts } from '../../../helpers';
import { Link } from 'react-router-dom';

const BreadcrumbData = [
  {
    id: 1,
    page_title: "Dashboard",
    page_path: "/",
    icon: "tachometer",
  },
  {
    id: 2,
    page_title: "Create Category",
    page_path: "/",
    icon: "tachometer",
  }
]
const CreateCategory = () => {
  const [isLoading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();


  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [parent_id, setSetParentId] = useState(0);



  let files = acceptedFiles.map(file => (
    <li key={file.name}>
      {file.name} - {file.size} bytes
    </li>
  ));
const getCategoriesData = async () =>{
   let resp = await Categories.getCategoriesWithTopLevel();
   if(resp && resp.status){

    setCategories(resp.categories);
    console.log(resp);
   }
}
  useEffect(()=>{
    getCategoriesData();
  },[])

  const handleSubmit = async (e) =>{
      e.preventDefault();
      setLoading(true);
      let formData = new FormData()
      for (let i = 0; i < acceptedFiles.length; i++) {
          formData.append("images", acceptedFiles[i]);
      }
      formData.append("name",name);
      formData.append("description", description);
      formData.append("parent_id", parent_id);
      let resp = await Categories.createCategory(formData);
      if(resp){
        if(resp.status){
          Alerts.alertMessage(resp.message, '', 'success');
          setLoading(false);
          window.setTimeout( function(){
            window.location = "/app/categories";
        }, 100 );
        }else{
          Alerts.alertMessage(resp.message, '', 'danger')
        }
       
      }
      
      
  }

  return (
    <>
      <Breadcumb items={BreadcrumbData} />
      <div className="page-wrapper pd30">
        <Container>
          <Card className="card">
            <CardContent>
            <div className='page-inner-header'>
                <h3 className='m-0'>Create Category</h3>
                <Link to={`/app/categories`} className="btn-primary action-btn">
                  Categories
                </Link>
              </div>
              
              <form onSubmit={handleSubmit} enctype='multipart/form-data'>
                <Grid container spacing={3}>
                  <Grid item xs={6}>

                    <div className='form-group'>
                      <TextField
                        label="Name"
                        variant="outlined"
                        fullWidth
                        size="small"
                        value={name}
                        onChange={(e)=>setName(e.target.value)}
                      />
                    </div>
                    <div className='form-group'>
                      <label className='input-label'>Description</label>
                      <CKEditor
                        editor={ClassicEditor}
                        data={description}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setDescription(data);
                          // console.log({ event, editor, data });
                        }}
                     
                      />
                    </div>
                    <div className='form-group'>
                      <select className='form-control' onChange={(e)=>setSetParentId(e.target.value)}>
                        <option value={``}>---Select Category---</option>
                         {
                            categories && categories.length !== 0 && categories.map((item, i)=>{
                              return  (
                                <>
                                  <option value={item.id} className='maincategory'>{item.name}</option>
                                  {
                                  item.subcategories.map(item2=>{
                                    return (
                                      <>
                                      <option value={item2.id} className='subcategory'>{item2.name}</option>
                                      {
                                         item2.subcategories.map(item3=>{
                                           return  <option value={item3.id} className='subsubcategory'>  {`>> ${item3.name}`}</option>
                                         })
                                      }
                                      </>
                                    )
                                  })
                                }
                                  
                                </>
                              
                              )
                            })
                          }
                      </select>
                      {/* <FormControl variant="outlined" style={{ width: '100%' }} size="small">
                        <InputLabel id="parent_category">Parent Category</InputLabel>
                        <Select
                          labelId="parent_category"
                          label="Parent Category"
                          onChange={(e)=>setSetParentId(e.target.value)}
                        >
                          <MenuItem value="">
                            <em>--Select Category--</em>
                          </MenuItem>
                          {
                            categories && categories.length !== 0 && categories.map((item, i)=>{
                              return (
                                <>
                                <MenuItem value={item.id}>{item.name}</MenuItem>
                                {
                                  item.subcategories.map(item2=>{
                                    return (
                                      <>
                                       <MenuItem className='subcategory' value={item2.id}>{item2.name}</MenuItem>
                                       {
                                          item2.subcategories.map(item3=>{
                                            return <MenuItem className='subcategory' value={item3.id}>{item3.name}</MenuItem>
                                          })
                                       }

                                      </>
                                   
                                    )
                                  })
                                }
                                </>
                              )
                            })
                          }
                        </Select>
                      </FormControl> */}
                    </div>
                  </Grid>
                  <Grid item xs={6}>
                    <label className='input-label'>Categories Thumbnails</label>
                    <section className="container">
                      <div {...getRootProps({ className: 'dropzone disabled dropzone2' })}>
                        <input {...getInputProps()} />
                        <p>Drag 'n' drop some files here, or click to select files</p>
                      </div>
                      <aside>
                        <h6 style={{ margin: 10 }}>Files</h6>
                        <ul>{files}</ul>
                      </aside>
                    </section>

                  </Grid>
                </Grid>

                <Button type='submit' variant="contained" color="primary">
                   {isLoading ? 'Please wait..' : 'Submit'}  
                </Button>
              </form>
            </CardContent>
          </Card>
        </Container>
      </div>

    </>
  )
}

export default CreateCategory